export default __webpack_public_path__ + "static/media/Boots of the Wicked.247c1e07.jpg";